import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectsHeader: {
		id: 'spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header',
		defaultMessage: 'Projects',
		description: 'Title of the projects section in the sidebar navigation.',
	},
});
